import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Dashboard.css';

function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation(); // ✅ inside the component
  const { user } = location.state || {}; // get user from navigation state

  const [features, setFeatures] = useState([]);

  useEffect(() => {
    if (user?.authorisedPages) {
      setFeatures(user.authorisedPages); // only authorised pages
    }
  }, [user]);

  const goToPage = (feature) => {
    navigate(`/${feature.toLowerCase()}`);
  };

  return (
    <div className="dashboard">
      <h2>Dashboard</h2>
      <div className="icon-grid">
        {features.map((feature) => (
          <div key={feature} className="icon-box" onClick={() => goToPage(feature)}>
            <span role="img" aria-label={feature}>📁</span>
            <p>{feature}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
